<div class="card card-body">
    <div class="d-flex">
        <i class="fas fa-user-lock fa-3x" [ngClass]="layout.headerColor.colorText"></i>
        <div class="p-2 ml-2">
            <h2 class="card-title" [ngClass]="layout.headerColor.colorText">Acesso Negado</h2>
            <p [ngClass]="layout.secondaryColor.colorText">
                Seu usuário não tem permissão para acessar este conteúdo ou executar essa ação.
            </p>
        </div>
    </div>
</div>
